import React from 'react'

export const NoMatch = () => {
    return (
        <div>
            This is no match.
        </div>
    )
}
